import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { PaycellInfoDialogAction } from './../../buy/paycell-info-dialog/paycell-info-dialog.action';

/* @ngInject */
export default class PacketCardController {
  constructor(private actionDispatcher: ActionDispatcherService) {}

  public showPaycellInfo() {
    this.actionDispatcher.dispatch(new PaycellInfoDialogAction());
  }
}



// WEBPACK FOOTER //
// ./src/app/components/paycell-info-link/paycell-info-link.controller.ts